<template>
  <div id="my-report-detail">
    <div class="container">
      <div class="content-container">
        <textarea class="contents" v-model="moreReport" disabled />
      </div>

      <div class="button-group">
        <div class="button" @click="onGetFullReportClick">
          Check here and choose your fully customized reports
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/utils/common'
import ReportService from '@/services/report-service'

export default {
  name: 'MyReportDetail',
  mixins: [common],
  data() {
    return {
      moreReport: ''
    }
  },
  created() {
    this.$parent.setNav(true)
    this.$parent.setHeader('My Report')
    this.$parent.headerClose = true
    this.$parent.setBottomTab(false)

    this.performGetMyReport()
  },
  methods: {
    performGetMyReport() {
      ReportService.getMyReport().then(({ resultCode, resultData }) => {
        if (resultCode === 0 && !this.isEmpty(resultData)) {
          var moreReport = `
            ${resultData.lbiMent}\n
            ${resultData.rbiMent}\n
            ${resultData.aiMent}\n
            ${resultData.hiMent}\n
            ${resultData.wciMent}
          `

          this.moreReport = moreReport
        }
      })
    },
    onGetFullReportClick() {
      this.goPageWithParams('Payment', { paymentTab: 'report' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="@/scss/my-report-detail.scss" scoped></style>
